import { NavLink, useLocation } from "react-router-dom";
import {
    LayoutDashboard,
    Users,
    Radio,
    Activity,
    BarChart3,
    Bell,
    Settings,
    LogOut,
    Link2,
    Gem,
    Eye,
} from "lucide-react";
import { BrandMark } from "@/components/BrandMark";
import { Button } from "@/components/ui/button";
import { clearToken } from "@/lib/api";

const NAV = [
    {
        to: "/",
        label: "نظرة عامة",
        icon: LayoutDashboard,
        testId: "sidebar-nav-overview",
    },
    {
        to: "/groups",
        label: "المجموعات",
        icon: Users,
        testId: "sidebar-nav-groups",
    },
    {
        to: "/channels",
        label: "القنوات",
        icon: Radio,
        testId: "sidebar-nav-channels",
    },
    {
        to: "/invite-links",
        label: "روابط الدعوة",
        icon: Link2,
        testId: "sidebar-nav-invite-links",
    },
    {
        to: "/live",
        label: "الأحداث المباشرة",
        icon: Activity,
        testId: "sidebar-nav-live-events",
    },
    {
        to: "/analytics",
        label: "التحليلات",
        icon: BarChart3,
        testId: "sidebar-nav-analytics",
    },
    {
        to: "/premium",
        label: "ذكاء البريميوم",
        icon: Gem,
        testId: "sidebar-nav-premium",
    },
    {
        to: "/views-alerts",
        label: "تنبيهات المشاهدات",
        icon: Eye,
        testId: "sidebar-nav-views-alerts",
    },
    {
        to: "/alerts",
        label: "التنبيهات",
        icon: Bell,
        testId: "sidebar-nav-alerts",
    },
    {
        to: "/settings",
        label: "إعدادات البوت",
        icon: Settings,
        testId: "sidebar-nav-bot-settings",
    },
];

export const Sidebar = ({ mobile = false, onNavigate } = {}) => {
    const location = useLocation();
    const handleLogout = () => {
        clearToken();
        window.location.href = "/login";
    };
    return (
        <aside
            className={`${mobile ? "flex flex-col h-full w-full" : "sticky top-0 z-30 hidden h-screen w-60 shrink-0 border-l border-border/60 md:flex md:flex-col"} bg-card/40 backdrop-blur-md`}
            data-testid="app-sidebar"
        >
            <div className="flex items-center justify-between px-4 py-4 border-b border-border/60">
                <BrandMark />
            </div>
            <nav className="flex-1 overflow-y-auto px-2 py-3">
                <ul className="space-y-1">
                    {NAV.map((item) => {
                        const active =
                            location.pathname === item.to ||
                            (item.to !== "/" &&
                                location.pathname.startsWith(item.to));
                        const Icon = item.icon;
                        return (
                            <li key={item.to}>
                                <NavLink
                                    to={item.to}
                                    data-testid={item.testId}
                                    onClick={onNavigate}
                                    className={`flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-150 ${
                                        active
                                            ? "bg-primary/10 text-primary border border-primary/20"
                                            : "text-muted-foreground hover:bg-muted/40 hover:text-foreground"
                                    }`}
                                >
                                    <Icon className="h-4 w-4 shrink-0" />
                                    <span className="truncate">
                                        {item.label}
                                    </span>
                                </NavLink>
                            </li>
                        );
                    })}
                </ul>
            </nav>
            <div className="border-t border-border/60 p-3">
                <Button
                    variant="ghost"
                    size="sm"
                    className="w-full justify-start gap-2 text-muted-foreground hover:text-foreground"
                    onClick={handleLogout}
                    data-testid="sidebar-logout-button"
                >
                    <LogOut className="h-4 w-4" />
                    تسجيل الخروج
                </Button>
            </div>
        </aside>
    );
};

export default Sidebar;
